import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { PlayerMutationKeys } from '../../../keys'
import {
	ToggleDemoAccountRequest,
	ToggleDemoAccountResponse,
} from '../../../type'
import { toggleDemoAccount } from '../../services'

export default function useMutationToggleDemoAccount(
	props?: UseBaseMutationOptions<
		ToggleDemoAccountResponse,
		ToggleDemoAccountRequest
	>,
) {
	return useMutation({
		mutationKey: [PlayerMutationKeys.ToggleDemoAccount],
		mutationFn: (params) => toggleDemoAccount(params),
		...props,
	})
}
